import { render, staticRenderFns } from "./ModalAttacment.vue?vue&type=template&id=300b118d"
import script from "./ModalAttacment.vue?vue&type=script&lang=js"
export * from "./ModalAttacment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports